import React, { useEffect, useState } from 'react';

export default function AdminLedger() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ chain: '', token_symbol: '', address: '' });
  const [tokens, setTokens] = useState([]);

  const truncate = (address) => {
    if (!address) return '';
    return address.length > 12 ? `${address.slice(0, 6)}...${address.slice(-4)}` : address;
  };

  const formatAmount = (val) => {
    const n = Number(val);
    return Number.isFinite(n) ? n.toFixed(5) : String(val);
  };

  const copyToClipboard = async (text) => {
    try { await navigator.clipboard.writeText(text || ''); } catch (e) { console.error('copy failed', e); }
  };

  const fetchItems = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.chain) params.append('chain', filters.chain);
      if (filters.token_symbol) params.append('token_symbol', filters.token_symbol);
      if (filters.address) params.append('address', filters.address);
      const res = await fetch(`/api/ledger/transactions?${params.toString()}`, {
        headers: { 'X-API-Key': (process.env.REACT_APP_SOULWARS_API_KEY || 'dev-key') }
      });
      const json = await res.json();
      setItems(json.data || []);
    } catch (e) {
      console.error('Failed to load transactions', e);
    } finally {
      setLoading(false);
    }
  };

  const fetchTokens = async () => {
    try {
      const res = await fetch('/api/ledger/tokens', {
        headers: { 'X-API-Key': (process.env.REACT_APP_SOULWARS_API_KEY || 'dev-key') }
      });
      const json = await res.json();
      setTokens(json.data || []);
    } catch (e) {
      console.error('Failed to load tokens', e);
    }
  };

  useEffect(() => { fetchItems(); fetchTokens(); /* eslint-disable-next-line */ }, []);

  const symbolFor = (it) => {
    const addr = it.token_address || null;
    if (!addr) return it.token_symbol;
    const t = tokens.find(x => x.chain === it.chain && x.token_address === addr);
    return (t && t.token_symbol) || it.token_symbol;
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>Ledger Transactions</h2>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <select value={filters.chain} onChange={e => setFilters({ ...filters, chain: e.target.value })}>
          <option value="">All Chains</option>
          <option value="solana">Solana</option>
          <option value="sui">SUI</option>
        </select>
        <input placeholder="Token Symbol" value={filters.token_symbol} onChange={e => setFilters({ ...filters, token_symbol: e.target.value })} />
        <input placeholder="Address (to/from)" value={filters.address} onChange={e => setFilters({ ...filters, address: e.target.value })} />
        <button onClick={fetchItems}>Search</button>
      </div>
      {loading ? (<div>Loading...</div>) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Time</th>
              <th>Chain</th>
              <th>Token</th>
              <th>Amount</th>
              <th>From</th>
              <th>Tx</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {(items || []).map((it, idx) => (
              <tr key={idx}>
                <td>{new Date(it.created_at || it.block_time || Date.now()).toLocaleString()}</td>
                <td>{it.chain}</td>
                <td>{symbolFor(it)}</td>
                <td>{formatAmount(it.amount_decimal)}</td>
                <td style={{ fontFamily: 'monospace' }}>
                  <span>{truncate(it.from_address)}</span>
                  <button
                    onClick={() => copyToClipboard(it.from_address)}
                    title="Copy"
                    style={{ marginLeft: 8, fontSize: 12 }}
                  >📋</button>
                </td>
                <td style={{ fontFamily: 'monospace' }}>
                  <span>{truncate(it.tx_id)}</span>
                  <button
                    onClick={() => copyToClipboard(it.tx_id)}
                    title="Copy"
                    style={{ marginLeft: 8, fontSize: 12 }}
                  >📋</button>
                </td>
                <td>{it.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}


